import QMenuItemGroup from '../menu/src/menu-item-group';

export default QMenuItemGroup;
